module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-13-d4435b088183812740486087412e2aef.jpg";